<template>
    <font-awesome-icon v-if="isLoading" icon="spinner" spin/>
    <div v-else>
        <b-row class="mb-3">
            <b-col cols="5" class="pt-1">
                Vervoerder:
            </b-col>
            <b-col cols="7">
                <b-select v-model="carrierId">
                    <b-select-option v-for="carrier in carriersForSelectedDispatcherAndDispatchType(dispatchRequest)" :key="carrier.id" :value="carrier.id" v-text="carrier.display_name"/>
                </b-select>
            </b-col>
        </b-row>
        <b-row class="mb-3" :key="carrierId">
            <b-col cols="5" class="pt-1">
                Vervoersmethode:
            </b-col>
            <b-col cols="7">
                <b-select v-model="dispatchRequest.carrier_method_id">
                    <b-select-option v-for="carrierMethod in availableCarrierMethods" :key="carrierMethod.id" :value="carrierMethod.id" v-text="carrierMethod.display_name"/>
                </b-select>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {carrierMethodsForSelectedCarrierAndDispatcherAndDispatchType, carriersForSelectedDispatcherAndDispatchType, dispatchTypesForSelectedDispatcher} from "@/helpers/dispatch";

export default {
    name: 'SwitchCarrierMethod',

    props: {
        dispatchRequest: { required: true },
    },

    mounted() {
        this.$emit('dataChange', this.dispatchRequest.carrier_method_id)
        this.$store.dispatch('loadDispatchInfoForLocation', {type: this.dispatchRequest.dispatcher_type, identifier: this.dispatchRequest.dispatcher_identifier})
            .then(() => {
                this.carrierId = this.dispatchRequest.carrier_method.carrier_id
                this.setAvailableCarrierMethods()
                this.isLoading = false;
            })
    },

    data() {
        return {
            isLoading: true,
            carriers: [],
            carrierId: null,
            availableCarrierMethods: [],
        }
    },

    methods: {
        dispatchTypesForSelectedDispatcher,
        carriersForSelectedDispatcherAndDispatchType,
        carrierMethodsForSelectedCarrierAndDispatcherAndDispatchType,
        setAvailableCarrierMethods() {
            this.availableCarrierMethods = this.carrierMethodsForSelectedCarrierAndDispatcherAndDispatchType(this.dispatchRequest)
            // Zet de value automatisch op de eerste waarde
            this.dispatchRequest.carrier_method_id = this.availableCarrierMethods[0]?.id
        },
    },

    watch: {
        carrierId(val) {
            // Een beetje een hack: We veranderen hier de carrier_id van het ingeladen DRQ zodat we dit DRQ kunnen voeren aan de generieke functies om de beschikbare carrier-methods voor die carrier op te halen
            this.dispatchRequest.carrier_method.carrier_id = val
            this.setAvailableCarrierMethods()
        },
        'dispatchRequest.carrier_method_id': {
            handler(val) {
                this.$emit('dataChange', val)
            },
        }
    },
}
</script>
